"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Table_Row_1 = __importDefault(require("./Table.Row"));
var Table_Item_1 = __importDefault(require("./Table.Item"));
var RenderRow_1 = __importDefault(require("./RenderRow"));
var RowContext_1 = __importDefault(require("./RowContext"));
require("./Table.css");
var Text_1 = __importDefault(require("../Text"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var Select_1 = __importDefault(require("../Select"));
var __1 = require("..");
var utils_1 = require("./utils");
function Table(_a) {
    var headers = _a.headers, children = _a.children, massAction = _a.massAction, _b = _a.ruled, ruled = _b === void 0 ? true : _b, editMode = _a.editMode, _c = _a.spacing, spacing = _c === void 0 ? "base" : _c, _d = _a.skeleton, skeleton = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.marginEndScroll, marginEndScroll = _f === void 0 ? 1 : _f, onEditMode = _a.onEditMode, onEndScroll = _a.onEndScroll;
    var rowsCount = React.useMemo(function () { return React.Children.count(children); }, [
        children,
    ]);
    var allChecksUnSelected = React.useMemo(function () { return (0, utils_1.createSelectedValues)(rowsCount, false); }, [rowsCount]);
    var allChecksSelected = React.useMemo(function () { return (0, utils_1.createSelectedValues)(rowsCount, true); }, [rowsCount]);
    var _g = React.useState((0, utils_1.createSelectedValues)(rowsCount, false)), rowsState = _g[0], setRowsState = _g[1];
    var massActionSelectValue = React.useState("")[0];
    var _h = React.useState(false), massActionCheckValue = _h[0], setMassActionCheckValue = _h[1];
    var handleChangeRow = React.useCallback(function (event) {
        var newSelected = __spreadArray([], rowsState, true);
        newSelected[parseInt(event.name, 10)] = event.checked;
        setRowsState(newSelected);
        setMassActionCheckValue((0, utils_1.getNewMassActionCheckValue)(newSelected));
    }, [rowsState]);
    var handleOnChangeSelectMassAction = React.useCallback(function (event) {
        massAction.onChange({
            value: event.value,
            indexRows: (0, utils_1.getRowsId)(rowsState),
        });
        setMassActionCheckValue(false);
        setRowsState(allChecksUnSelected);
    }, [allChecksUnSelected, massAction, rowsState]);
    var handleOnChangeCheckMassAction = React.useCallback(function (event) {
        setMassActionCheckValue(event.checked);
        setRowsState(event.checked ? allChecksSelected : allChecksUnSelected);
    }, [allChecksSelected, allChecksUnSelected]);
    var memorizedMassAction = React.useMemo(function () {
        return massAction &&
            massActionCheckValue && (React.createElement("div", { className: "nimbus--table__mass-actions" },
            React.createElement("div", { className: "nimbus--table__mass-check" },
                React.createElement(Checkbox_1.default, { name: "check-all-mass-action", checked: massActionCheckValue, onChange: handleOnChangeCheckMassAction, label: massAction.getLabel((0, utils_1.quantitySelected)(rowsState)) })),
            React.createElement("div", { className: "nimbus--table__mass-select" },
                React.createElement(Select_1.default, { name: "select-mass-action", placeholder: massAction.placeholder, options: massAction.options, value: massActionSelectValue, onChange: handleOnChangeSelectMassAction }))));
    }, [
        handleOnChangeCheckMassAction,
        handleOnChangeSelectMassAction,
        massAction,
        massActionCheckValue,
        massActionSelectValue,
        rowsState,
    ]);
    var memorizedHeader = React.useMemo(function () {
        return !(massAction && massActionCheckValue) &&
            headers && (React.createElement("thead", { className: "nimbus--table__header" },
            React.createElement("tr", { className: "nimbus--table-row" },
                massAction && (React.createElement("th", { className: "nimbus--table-row__check" }, skeleton ? (React.createElement(Checkbox_1.default, { name: "check-all", disabled: true })) : (React.createElement(Checkbox_1.default, { name: "check-all", checked: massActionCheckValue, onChange: handleOnChangeCheckMassAction })))),
                headers.map(function (header) { return (React.createElement("th", { scope: "col", key: header, className: "nimbus--table-row__item" },
                    React.createElement(Text_1.default, null, header))); }))));
    }, [
        handleOnChangeCheckMassAction,
        headers,
        massAction,
        massActionCheckValue,
        skeleton,
    ]);
    var targetID = React.useRef(null);
    React.useEffect(function () {
        var margin = Math.trunc(window.innerHeight * marginEndScroll);
        var options = {
            rootMargin: "0px 0px ".concat(margin, "px 0px"),
        };
        var callback = function (entries) {
            if (entries[0].isIntersecting) {
                onEndScroll === null || onEndScroll === void 0 ? void 0 : onEndScroll();
                observer.disconnect();
            }
        };
        var observer = new IntersectionObserver(callback, options);
        observer.observe(targetID.current);
        var newRowState = __spreadArray(__spreadArray([], rowsState, true), (0, utils_1.createSelectedValues)(React.Children.count(children) - rowsState.length, false), true);
        setRowsState(newRowState);
        setMassActionCheckValue((0, utils_1.getNewMassActionCheckValue)(newRowState));
        return function () {
            observer.disconnect();
        };
    }, [children]);
    var className = React.useMemo(function () {
        return (0, classnames_1.default)("nimbus--table-wrapper", { "nimbus--table-wrapper--ruled": ruled }, { "nimbus--table-wrapper--actions": massAction && editMode }, { "nimbus--table-wrapper--edit-mode": editMode }, "nimbus--table-wrapper--spacing-".concat(spacing));
    }, [editMode, massAction, ruled, spacing]);
    React.useEffect(function () {
        if (!editMode) {
            setMassActionCheckValue(false);
            setRowsState(allChecksUnSelected);
        }
    }, [allChecksUnSelected, editMode]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className },
            memorizedMassAction,
            React.createElement("table", { className: "nimbus--table" },
                memorizedHeader,
                React.createElement("tbody", { className: "nimbus--table__body" }, React.Children.map(children, function (row, index) {
                    return (React.createElement(React.Fragment, null, row && (React.createElement(RowContext_1.default, { key: index },
                        React.createElement(RenderRow_1.default, { skeleton: skeleton, editMode: editMode, massAction: massAction, index: index, rowsState: rowsState, onChangeRow: handleChangeRow, onEditMode: function (event) {
                                handleChangeRow(event);
                                if (!editMode)
                                    onEditMode === null || onEditMode === void 0 ? void 0 : onEditMode();
                            } }, row)))));
                }))),
            React.createElement("div", { className: "nimbus--table-bottom", ref: targetID }),
            loading && (React.createElement("div", { className: "nimbus--spinner-wrapper" },
                React.createElement(__1.Spinner, { size: "large" }))))));
}
Table.Row = Table_Row_1.default;
Table.Item = Table_Item_1.default;
exports.default = Table;
//# sourceMappingURL=index.js.map